
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"obrasValidadasSinSolicitud"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ejercicio"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obrasValidadasSinSolicitud"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ejercicio"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ejercicio"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clave"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"meta"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"idPrograma"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ubicacion"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idMunicipio"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"localidad"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tipoLocalidad"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cabeceraMunicipial"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"impacto"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"beneficiados"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"metaFisica"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"metaFisicaUnidad"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"justificacionSocial"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"justificacionTecnica"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"problematica"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"conceptosEjecutar"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"tipoProyecto"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fechaProbableInicio"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fechaProbableTermino"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"total"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":506}};
    doc.loc.source = {"body":"query obrasValidadasSinSolicitud($ejercicio: Int!) {\n  obrasValidadasSinSolicitud(ejercicio: $ejercicio) {\n    id\n    clave\n    meta\n    idPrograma\n    ubicacion {\n      idMunicipio\n      localidad\n      tipoLocalidad\n      cabeceraMunicipial\n    }\n    impacto {\n      beneficiados\n      metaFisica\n      metaFisicaUnidad\n      justificacionSocial\n      justificacionTecnica\n      problematica\n      conceptosEjecutar\n    }\n    tipoProyecto\n    fechaProbableInicio\n    fechaProbableTermino\n    total\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["obrasValidadasSinSolicitud"] = oneQuery(doc, "obrasValidadasSinSolicitud");
        
